module.exports = __webpack_public_path__ + "static/media/telcos.f1e030f0.png";